<app-secured-image *ngIf="!isOldImage" [src]="value"></app-secured-image>
<img *ngIf="isOldImage" [src]="value" class="car-img" onerror="this.style.display='none'"/>
